/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation, useParams } from "react-router-dom";
import useFormatById from "src/hooks/utils/useFormatById";

export const routesSubroutes = {
  "/blogs": ["/home", "/blogs"],
  "/about-us": ["/home", "/about-us"],
  "/more-about-insurance": ["/home", "/more-about-insurance"],
  "/our-team": ["/home", "/our-team"],
  "/vacancy": ["/home", "/vacancy"],
  "/offices": ["/home", "/offices"],
  "/legal-info": ["/home", "/legal-info"],
  "/financial-info": ["/home", "/financial-info"],
  "/evaluations": ["/home", "/evaluations"],
  "/blog-details/:id": ["/home", "/blogs", "/blog-details/:id"],
  // "/travel": ["/home", "/travel"],
  "/travel/:id": ["/home", "/travel/:id"],
  "/student": ["/home", "/student"],
  // "/insurance-and-more": ["/home", "/insurance-and-more"],
  "/chat-bot": ["/home", "/chat-bot"],
  "/ind-health-insurance/buypage": [
    "/home",
    "/ind-health-insurance",
    "/ind-health-insurance/buypage",
  ],
  "/ind-health-insurance/paypage": [
    "/home",
    "/ind-health-insurance",
    "/ind-health-insurance/paypage",
  ],
  "/payment-result": ["/home", "/payment-result"],
  "/corp-insurance": ["/home", "/corp-insurance"],
  "/gepha-proposal": ["/home", "/gepha-proposal"],
  "/uno/buyPage": ["/home", "/uno", "/uno/buyPage"],
  "/uno/paypage": ["/home", "/uno", "/uno/paypage"],

  // "/visitors-insurance": ["/home", "/visitors-insurance"],
  "/tootsie-event": ["/home", "/tootsie-event"],
  "/privacy-policy": ["/home", "/privacy-policy"],
  "/privacy-statement": ["/home", "/privacy-statement"],

  "/uno-active/buy": ["/home", "/uno-active", "/uno-active/buy"],
  "/uno-active/pay": ["/home", "/uno-active", "/uno-active/pay"],

  "/uno-select/buy": ["/home", "/uno-select", "/uno-select/buy"],
  "/uno-select/pay": ["/home", "/uno-select", "/uno-select/pay"],
};

const Breadcrumb = () => {
  const f = useFormatById();

  const routes = {
    "/home": f("breadCrumb.home"),
    // "/insurance-and-more": f("breadCrumb.insurance-and-more"),
    "/evaluations": f("breadCrumb.evaluations"),
    "/blogs": f("breadCrumb.blogs"),
    "/student": f("breadCrumb.student"),
    "/vacancy": f("breadCrumb.vacancy"),
    "/about-us": f("breadCrumb.aboutus"),
    "/offices": f("breadCrumb.offices"),
    "/chat-bot": f("breadCrumb.chat-bot"),
    "/our-team": f("breadCrumb.our-team"),
    "/more-about-insurance": f("breadCrumb.more-about-insurance"),
    "/legal-info": f("breadCrumb.legal-info"),
    "/financial-info": f("breadCrumb.financial-info"),
    "/corp-insurance": f("breadCrumb.corp-insurance"),
    "/travel": f("breadCrumb.travel"),
    "/travel/:id": f("breadCrumb.travel"),
    "/blog-details/:id": f("breadCrumb.blog-details"),
    "/ind-health-insurance": f("breadCrumb.saerto"),
    "/ind-health-insurance/buypage": f("breadCrumb.saerto.buypage"),
    "/ind-health-insurance/paypage": f("breadCrumb.saerto.paypage"),
    "/payment-result": f("breadCrumb.paymentResult"),
    "/gepha-proposal": f("breadCrumb.gephaProposal"),
    "/uno": f("breadCrumb.uno"),
    "/uno/buyPage": f("breadCrumb.uno.buypage"),
    "/uno/paypage": f("breadCrumb.uno.paypage"),
    // "/visitors-insurance": f("breadCrumb.InsideTravelInsurance"),
    "/tootsie-event": f("breadCrumb.tootsie"),
    "/privacy-policy": f("breadCrumb.privacyPolicies"),
    "/privacy-statement": f("breadCrumb.privacyStatement"),
    "/uno-active": f("breadCrumb.uno-active"),
    "/uno-active/buy": f("breadCrumb.uno-active.buypage"),
    "/uno-active/pay": f("breadCrumb.uno-active.paypage"),
    "/uno-select": f("breadCrumb.uno-select"),
    "/uno-select/buy": f("breadCrumb.uno-select.buypage"),
    "/uno-select/pay": f("breadCrumb.uno-select.paypage"),
  };

  const location = useLocation();
  const lang = useSelector((state) => state.common.lang);

  const transformRouteWithId = (path) => {
    const pathSegments = path.split("/").filter(Boolean);

    const guidPattern =
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
    for (let i = 0; i < pathSegments.length; i++) {
      const segment = pathSegments[i];

      if (!isNaN(segment) || guidPattern.test(segment)) pathSegments[i] = ":id";

      if (segment === lang) pathSegments[i] = "";
    }

    return `/${pathSegments.join("/")}`;
  };

  let transformedRoute = transformRouteWithId(location.pathname);
  if (transformedRoute[transformedRoute.length - 1] === "/")
    transformedRoute = transformedRoute.slice(0, -1);

  return (
    <div id="breadcrumb">
      {routesSubroutes.hasOwnProperty(transformedRoute) && (
        <div className="container mt-4">
          {routesSubroutes?.[transformedRoute]?.map((link, index) => (
            <span key={index}>
              {index !== 0 && " > "}
              {transformedRoute === link ? (
                <a style={{ color: "#163165" }}>{routes[link]}</a>
              ) : (
                <Link
                  to={link + "/" + lang}
                  style={{ color: "rgba(69, 64, 64, 0.70)" }}
                >
                  {routes[link]}
                </Link>
              )}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default Breadcrumb;
